const Active = '433a217a-9ff0-420e-9ed0-1668a38213aa'
const Template = '2625adda-9833-4ac0-8b66-d7be03b40bfe'
const Deleted = '874d47cb-fb36-43a8-8b3a-05f658e2a17d'

export { Active, Template, Deleted }